const LOGO = `
  <div style="display:flex;align-items:center;gap:10px;margin-bottom:4px">
    <div style="display:flex;flex-direction:column;gap:3px">
      <div style="width:22px;height:3px;background:#FF4100;border-radius:2px"></div>
      <div style="width:16px;height:3px;background:#FF4100;border-radius:2px"></div>
      <div style="width:22px;height:3px;background:#FF4100;border-radius:2px"></div>
    </div>
    <span style="font-size:18px;font-weight:900;letter-spacing:-0.5px;color:#111">WEBusiness</span>
  </div>`;

function header(title, subtitle) {
  return `
  <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:24px;padding-bottom:16px;border-bottom:2px solid #3B82F6">
    ${LOGO}
    <div style="text-align:right">
      <div style="font-size:11px;color:#666">Imprimé le ${new Date().toLocaleDateString('fr-FR')}</div>
    </div>
  </div>
  <h2 style="font-size:16px;font-weight:800;margin:0 0 4px">${title}</h2>
  ${subtitle ? `<p style="font-size:11px;color:#666;margin:0 0 20px">${subtitle}</p>` : ''}`;
}

function rows(fields) {
  return `
  <table style="width:100%;border-collapse:collapse;font-size:12px">
    ${fields.map(([label, value], i) => `
    <tr style="background:${i % 2 === 0 ? '#f9f9f9' : '#fff'}">
      <td style="padding:8px 12px;font-weight:600;color:#444;width:38%;border:1px solid #e5e7eb">${label}</td>
      <td style="padding:8px 12px;color:#111;border:1px solid #e5e7eb">${value ?? '—'}</td>
    </tr>`).join('')}
  </table>`;
}

function statut(s) {
  const map = {
    VALIDE: ['Validé', '#059669'],
    REFUSE: ['Refusé', '#DC2626'],
    REJETE: ['Rejeté', '#DC2626'],
    SOUMIS: ['En attente', '#0891B2'],
    BROUILLON: ['Brouillon', '#6B7280'],
  };
  const [label, color] = map[s] || [s, '#6B7280'];
  return `<span style="display:inline-block;padding:2px 10px;border-radius:20px;font-size:11px;font-weight:700;background:${color}20;color:${color}">${label}</span>`;
}

function open(body) {
  const w = window.open('', '_blank');
  if (!w) return;
  w.document.write(`<!DOCTYPE html><html lang="fr"><head><meta charset="utf-8">
    <title>WEBusiness — Export</title>
    <style>
      body { font-family: Arial, sans-serif; padding: 32px; max-width: 720px; margin: 0 auto; color: #111; }
      @media print { body { padding: 16px; } }
    </style>
  </head><body>${body}<script>window.onload=()=>window.print();<\/script></body></html>`);
  w.document.close();
}

function fmtDate(iso) {
  if (!iso) return '—';
  const [y, m, d] = (iso.split('T')[0]).split('-');
  return `${d}/${m}/${y}`;
}
function fmtMontant(v) {
  return v != null ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(v) : '—';
}

// ── Note de frais ────────────────────────────────────────────────
export function exportNoteFraisPDF(nf) {
  const who = nf.user_prenom ? `${nf.user_prenom} ${nf.user_nom}` : null;
  open(`
    ${header(`Note de frais — ${nf.designation || ''}`, who ? `Collaborateur : ${who}` : '')}
    ${rows([
      ['Numéro', nf.numero ? `#${nf.numero}` : '—'],
      ['Désignation', nf.designation],
      ['Poste', nf.poste],
      ['Date de dépense', fmtDate(nf.date_effet)],
      ['Montant TTC', fmtMontant(nf.montant_ttc)],
      ['TVA 5,5 %', fmtMontant(nf.tva_5_5)],
      ['TVA 10 %', fmtMontant(nf.tva_10)],
      ['TVA 20 %', fmtMontant(nf.tva_20)],
      ['Projet', nf.project_nom || '—'],
      ['Commentaire', nf.commentaire || '—'],
      ['Statut', statut(nf.statut)],
      ['Date de traitement', fmtDate(nf.date_validation)],
      ['Commentaire RH', nf.commentaire_valideur || '—'],
    ])}
  `);
}

export function exportNoteFraisCSV(nf) {
  const who = nf.user_prenom ? `${nf.user_prenom} ${nf.user_nom}` : '';
  const lines = [
    ['Numéro', nf.numero ? `#${nf.numero}` : ''],
    ['Collaborateur', who],
    ['Désignation', nf.designation || ''],
    ['Poste', nf.poste || ''],
    ['Date de dépense', fmtDate(nf.date_effet)],
    ['Montant TTC', nf.montant_ttc ?? ''],
    ['TVA 5,5 %', nf.tva_5_5 ?? ''],
    ['TVA 10 %', nf.tva_10 ?? ''],
    ['TVA 20 %', nf.tva_20 ?? ''],
    ['Projet', nf.project_nom || ''],
    ['Commentaire', nf.commentaire || ''],
    ['Statut', nf.statut || ''],
    ['Date traitement', fmtDate(nf.date_validation)],
    ['Commentaire RH', nf.commentaire_valideur || ''],
  ];
  _downloadCSV(lines, `note_frais_${nf.numero || nf.id}`);
}

// ── Arrêt maladie ────────────────────────────────────────────────
export function exportArretMaladiePDF(a) {
  const who = a.user_prenom ? `${a.user_prenom} ${a.user_nom}` : null;
  const notes = [];
  if (a.depart_midi) notes.push('Départ à midi le premier jour');
  if (a.retour_midi) notes.push('Retour à midi le dernier jour');
  open(`
    ${header('Arrêt maladie', who ? `Collaborateur : ${who}` : '')}
    ${rows([
      ['Date de début', fmtDate(a.date_debut)],
      ['Date de fin', fmtDate(a.date_fin)],
      ['Durée', `${a.nb_jours} jour(s)`],
      ['Notes', notes.join(' · ') || '—'],
      ['Statut', statut(a.statut)],
      ['Date de traitement', fmtDate(a.date_validation)],
      ['Commentaire RH', a.commentaire_rh || '—'],
    ])}
  `);
}

export function exportArretMaladieCSV(a) {
  const who = a.user_prenom ? `${a.user_prenom} ${a.user_nom}` : '';
  _downloadCSV([
    ['Collaborateur', who],
    ['Date de début', fmtDate(a.date_debut)],
    ['Date de fin', fmtDate(a.date_fin)],
    ['Durée (jours)', a.nb_jours ?? ''],
    ['Départ midi', a.depart_midi ? 'Oui' : 'Non'],
    ['Retour midi', a.retour_midi ? 'Oui' : 'Non'],
    ['Statut', a.statut || ''],
    ['Date traitement', fmtDate(a.date_validation)],
    ['Commentaire RH', a.commentaire_rh || ''],
  ], `arret_maladie_${a.id?.slice(0, 8) || 'export'}`);
}

// ── Absence / congé ─────────────────────────────────────────────
export function exportAbsencePDF(ab) {
  const who = ab.user_prenom ? `${ab.user_prenom} ${ab.user_nom}` : null;
  const typeLabel = {
    CONGE_PAYE: 'Congé payé',
    CONGE_SANS_SOLDE: 'Congé sans solde',
    RTT: 'RTT',
  }[ab.type_conge] || ab.type_conge;
  open(`
    ${header(`Demande de congé — ${typeLabel}`, who ? `Collaborateur : ${who}` : '')}
    ${rows([
      ['Type de congé', typeLabel],
      ['Date de début', fmtDate(ab.date_debut)],
      ['Date de fin', fmtDate(ab.date_fin)],
      ['Durée', `${ab.nb_jours} jour(s)`],
      ['Motif', ab.description || '—'],
      ['Statut', statut(ab.statut)],
      ['Date de traitement', fmtDate(ab.date_validation)],
      ['Commentaire RH', ab.commentaire_rh || '—'],
    ])}
  `);
}

export function exportAbsenceCSV(ab) {
  const who = ab.user_prenom ? `${ab.user_prenom} ${ab.user_nom}` : '';
  _downloadCSV([
    ['Collaborateur', who],
    ['Type de congé', ab.type_conge || ''],
    ['Date de début', fmtDate(ab.date_debut)],
    ['Date de fin', fmtDate(ab.date_fin)],
    ['Durée (jours)', ab.nb_jours ?? ''],
    ['Motif', ab.description || ''],
    ['Statut', ab.statut || ''],
    ['Date traitement', fmtDate(ab.date_validation)],
    ['Commentaire RH', ab.commentaire_rh || ''],
  ], `absence_${ab.id?.slice(0, 8) || 'export'}`);
}

// ── Interne ──────────────────────────────────────────────────────
function _downloadCSV(lines, filename) {
  const csv = '﻿' + lines
    .map(([k, v]) => `"${String(k).replace(/"/g, '""')}";"${String(v ?? '').replace(/"/g, '""')}"`)
    .join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href = url; a.download = `${filename}.csv`;
  document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
}
